export const Types = {
  SAVE_LIST_CATEGORY: 'SAVE_LIST_CATEGORY',
  SET_RECORD: 'SET_RECORD'
}
